import axios from 'axios'

const PREFIX = 'https://servicodados.ibge.gov.br/api/v1/localidades/'

/**
 * Cache global para estados brasileiros.
 * Estados não mudam, então podem ser armazenados em memória.
 */
let estadosCache = null
let estadosCachePromise = null

export default {
  /**
   * Retorna a lista de estados brasileiros.
   * Utiliza cache em memória para evitar requisições repetidas.
   */
  async getEstados() {
    // Retorna cache se já existir
    if (estadosCache) {
      return { data: estadosCache }
    }

    // Se já existe uma requisição em andamento, aguarda ela
    if (estadosCachePromise) {
      return estadosCachePromise
    }

    // Faz requisição e armazena em cache
    const uninterceptedAxiosInstance = axios.create()
    estadosCachePromise = uninterceptedAxiosInstance.get(`${PREFIX}estados`)
      .then(response => {
        estadosCache = response.data
        estadosCachePromise = null
        return response
      })
      .catch(err => {
        estadosCachePromise = null
        throw err
      })

    return estadosCachePromise
  },

  getEstado(ibge) {
    const uninterceptedAxiosInstance = axios.create()
    return uninterceptedAxiosInstance.get(`${PREFIX}estados/${ibge}`)
  },
}
